import React, { useContext, useEffect } from "react";
import { ProcessContext } from "../../../../contexts/ProcessContext";
import { AuthContext } from "../../../../contexts/AuthContext";
import { EVENTS_CONFIG, MILESTONES } from "./config";
import { useEventDispatcher } from "../../../../utils/hooks/useEventDispatcher";
import { ContextEventCatcher, EVENT_TYPES } from "nemuru-components";

export default function EventCatcher() {
  const { dispatchEvent } = useEventDispatcher();
  const {
    state: processContextState,
    state: {
      currentModuleObject,
      snackbarNotification,
      appStarted,
      screenPath,
    },
  } = useContext(ProcessContext);

  const { state: authContextState } = useContext(AuthContext);

  // const [catchedActions] = useState([]);

  useEffect(() => {
    currentModuleObject?.id && screenPath && dispatchProgressEvent();
  }, [screenPath]);

  useEffect(() => {
    currentModuleObject && currentModuleObject.id && dispatchProgressEvent();
  }, [currentModuleObject]);

  useEffect(() => {
    snackbarNotification &&
      snackbarNotification.snackbarInformation &&
      dispatchEvent({
        name: snackbarNotification.snackbarInformation.type,
        type: EVENT_TYPES.snackbar,
        payload: snackbarNotification,
      });
  }, [snackbarNotification]);

  useEffect(() => {
    if (appStarted) {
      dispatchEvent({
        name: MILESTONES.APP_STARTED,
        type: EVENT_TYPES.milestoneCompleted,
      });
    }
  }, [appStarted]);

  const dispatchProgressEvent = () => {
    const path = screenPath || currentModuleObject?.id;
    path &&
      dispatchEvent({
        name: path,
        type: EVENT_TYPES.progress,
        payload: {
          module: currentModuleObject?.id,
          screenPath: path,
          status: "ok",
        },
      });
  };

  return (
    <>
      <ContextEventCatcher
        context={processContextState}
        eventsConfig={EVENTS_CONFIG}
        dispatchEventFunction={dispatchEvent}
      />
      <ContextEventCatcher
        context={authContextState}
        eventsConfig={EVENTS_CONFIG}
        dispatchEventFunction={dispatchEvent}
      />
    </>
  );
}
